import { CSSProperties } from 'react';
import { Button } from 'reactstrap';

import SvgRender from 'common/components/general/SvgRender';
import arrow from 'common/assets/svg/common/arrow.svg';
import { refetchPageTableData } from 'common/components/table/utils/helpers';
import { numberToStr } from 'common/utils/numbers';

type NavigationArrowProps = {
  style?: CSSProperties;
  disabled: boolean;
  onClick: () => void;
};

const NavigationArrow = ({ style = {}, disabled, onClick }: NavigationArrowProps) => (
  <Button
    color="primary"
    type="button"
    size="sm"
    className="d-flex p-0 height-16 width-16 align-items-center justify-content-center"
    onClick={onClick}
    disabled={disabled}
  >
    <SvgRender src={arrow} className="text-white" style={{ ...style, width: 9, height: 9 }} />
  </Button>
);

type Paging = {
  current_page: number;
  last_page: number;
  per_page: number | null;
  total: number;
  default_per_page: number;
};

type PaginationNavigationProps = {
  fetchData?: () => void;
  paging: Paging;
  scrollToTop?: boolean;
  customTableFetch?: ((params: { page: number }) => void) | null;
};

const PaginationNavigation = ({
  fetchData,
  paging,
  scrollToTop = false,
  customTableFetch = null
}: PaginationNavigationProps) => {
  const goToPage = (page: number) => {
    if (customTableFetch) {
      customTableFetch({ page });
    } else if (fetchData) {
      refetchPageTableData(fetchData, paging, page, scrollToTop);
    }
  };

  const isFirstPage = paging.current_page === 1;
  const isLastPage = paging.current_page === paging.last_page;
  const currentPage = paging.current_page || 1;
  const totalPages = paging.last_page || 1;

  return (
    <div className="d-flex align-items-center position-relative app-table--toptotal-navigation fs-12 text-primary">
      <NavigationArrow
        style={{ transform: 'rotate(90deg)' }}
        disabled={isFirstPage}
        onClick={() => goToPage(currentPage - 1)}
      />
      <div className="px-1">
        Page <strong>{numberToStr(currentPage)}</strong> of {numberToStr(totalPages)}
      </div>
      <NavigationArrow
        style={{ transform: 'rotate(-90deg)' }}
        disabled={isLastPage}
        onClick={() => goToPage(currentPage + 1)}
      />
    </div>
  );
};

export default PaginationNavigation;
